import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import MenuItem from "@mui/material/MenuItem";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import edit from "../../../../Assets/edit.svg";
import del from "../../../../Assets/Box.svg";

import ExcelIcon from "../../../../Assets/ExcelIcon.svg";
import "../button.css";
import { io } from "socket.io-client";

const socket = io('https://policydekhoo-backend.onrender.com');


const Credit = ({exportToExcel,setData}) => {
  const data=JSON.parse(localStorage.getItem("userData")).Permissions
  const [permissionsList,setpermissionsList]=useState([])
  
  // const top100Films = [
  //   { label: "The Shawshank Redemption", year: 1994 },
  //   { label: "The Godfather", year: 1972 },
  //   { label: "The Godfather: Part II", year: 1974 },
  //   { label: "The Dark Knight", year: 2008 },
  //   { label: "12 Angry Men", year: 1957 },
  //   { label: "Schindler's List", year: 1993 },
  //   { label: "Pulp Fiction", year: 1994 },
  // ];

  useEffect(() => {
    if(data!==null)
      {
    setpermissionsList(data.split(","))
      }
 
    socket.on('dataUpdatedCreditCard1', (updatedData) => {
        setData(updatedData)
        setCreditCardInsurancedata(updatedData);
    });
    socket.on('deleteData1', (Data) => {
        setData(Data)
        setCreditCardInsurancedata(Data);
    });
    return () => {
        socket.disconnect();
    };
}, []);


  const currencies = ["value1", "value2", "value3"];

  const rowsPerPageOptions = [5, 10, 25]; // Rows per page options

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);
    const [editcheck, seteditcheck] = React.useState(false);
    const [idselected, setidselected] = useState();

    const editdata = (e) => {
      // console.log(e);
      seteditcheck(false);
    };

    const [tableName, settablename] = useState("credit_card_insurance");

    const handleDelete = async (id) => {
      try {
        // Store the ID of the row when delete button is clicked
        setidselected(id);
        // console.log("Id to be deleted is : =======", id);

        // Construct the URL with the tableName and idselected
        const url = `https://policydekhoo-backend.onrender.com/Removedata?tableName=${tableName}&id=${id}`;

        // Make a DELETE request to the URL
        const response = await fetch(url, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        });

        // Check if the request was successful
        if (!response.ok) {
          throw new Error("Failed to delete data");
        }

        // Optionally, you can handle the response here
        const responseData = await response.json();
        const temp=[...CreditCardInsurancedata]
        let ind=""
        temp.map((val,index)=>{
          if(val.id===id){
            ind=index;
            console.log(val,index)
          }
        })
        temp.splice(ind,1);
        console.log(temp,"jaiiii");
        console.log("Delete response:", responseData);
        setCreditCardInsurancedata(temp)
        setData(temp)
      socket.emit('deleteDataCreditCard', temp);


        console.log("Delete response:", responseData);
        setCreditCardInsurancedata(temp)
        setData(temp)

        // Refresh the data after deletion
        // Call the function that fetches data again
        // getCarInsurancedata();
      } catch (error) {
        console.error("Error deleting data:", error);
      }
    };

    useEffect(() => {
      // console.log("Id to be deleted is : =======", idselected);
    }, [idselected]);

    const addvalues = (e) => {
      setdata2({ ...data2, [e.target.name]: e.target.value });
    };

    const [data2, setdata2] = useState({});

    console.log("data2", data2);

    const UpdateCreditCard = async (id) => {
      // setidselected(id);
      // console.log("Id to be updated is : =======", id);
      // e.preventDefault();

      try {
        // setidselected(id); // Set the ID first
        console.log(
          "===============data to be updated and id",
          data2,
          id,
          tableName
        );
        const response = await fetch(
          `https://policydekhoo-backend.onrender.com/Updatedata?tableName=${tableName}&id=${id}`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data2),
          }
        );

        if (response.ok) {
          const temp=[...CreditCardInsurancedata]
          let ind=""
          temp.map((val,index)=>{
            if(val.id===id)
              {
                ind=index
              }
          })
          const temp1={...temp[ind]}
          console.log(temp1,"[][][][][][[[[")    
          Object.keys(data2).map((k1)=>(
            temp1[k1]=data2[k1]
          )) 
          temp[ind]=(temp1);
          setCreditCardInsurancedata(temp) 
          setData(temp)
        socket.emit('editDataCreditCard', temp);

          console.log("Data updated successfully");
        } else {
          console.error("Failed to update data");
        }
      } catch (error) {
        console.error("Error:", error);
      }
      editdata();
    };

    return (
      <React.Fragment>
        <TableRow>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>

          {row.map((val, index) =>
            index <= 3 ? (
              editcheck ? (
                <TableCell align="left">
                  <TextField
                    id="outlined-size-small"
                    defaultValue={val}
                    size="small"
                    name={
                      index === 1
                        ? "Fullname"
                        : index === 2
                        ? "Email"
                        : index === 3
                        ? "Contact"
                        : ""
                    }
                  />
                </TableCell>
              ) : (
                <TableCell align="left">{val}</TableCell>
              )
            ) : (
              ""
            )
          )}
          <TableCell align="left" sx={{ whiteSpace: "nowrap" }}>
            {row[4] === "pending" ? (
              <label
                className="p-1 px-2 mx-1 rounded  pendng-bg"
                htmlFor="pending"
              >
                <b> Pending</b>
              </label>
            ) : (
              ""
            )}
            <label
              className={`p-1 px-2 mx-1 rounded ${
                row[4] === "accepted" ? "accepted-bg" : "border-accepted"
              }   `}
              htmlFor="Accepted"
            >
              <b>Accepted</b>
            </label>
            <label
              className={`p-1 px-2 mx-1 rounded ${
                row[4] === "denied" ? " denied-bg" : "border-denied"
              }`}
              htmlFor="Denied"
            >
              <b>Denied</b>
            </label>
          </TableCell>
          { permissionsList.includes("edit")||permissionsList.includes("delete")?
          <TableCell
            className="text-left"
            sx={{ minWidth: 100, whiteSpace: "nowrap" }}
          >
              { permissionsList.includes("edit")?
            <label className="me-1">
              <img
                src={edit}
                alt=""
                onClick={() => {
                  seteditcheck(true);
                }}
              />
            </label>:""}
              {permissionsList.includes("delete")?
            <label className="me-1">
              <img src={del} alt="" onClick={() => handleDelete(row[0])} />
            </label>:""}
          </TableCell>
          :""}
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                {/* <Typography variant="h6" gutterBottom component="div">
                  History
                </Typography> */}
                <Table size="medium" aria-label="purchases">
                  <TableBody className="text-left">
                    <TableRow>
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Occupation Type - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[5].occupationType}
                            size="small"
                            value={data2.Occupation_Type}
                            onChange={addvalues}
                            name="Occupation_Type"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Occupation Type - </b>
                          {row[5].occupationType}
                        </TableCell>
                      )}
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Monthly Income - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[5].MonthlyIncome}
                            value={data2.Monthly_Income}
                            onChange={addvalues}
                            name="Monthly_Income"
                            size="small"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Monthly Income - </b>
                          {row[5].MonthlyIncome}
                        </TableCell>
                      )}
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Current Residential Pin code - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[5].currentResidentialPincode}
                            size="small"
                            value={data2.Residential_Pincode}
                            onChange={addvalues}
                            name="Residential_Pincode"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Current Residential Pin code - </b>
                          {row[5].currentResidentialPincode}
                        </TableCell>
                      )}
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Do you Have Any Vehicle - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[5].doyouHaveAnyVehicle}
                            size="small"
                            value={data2.Have_Any_Vehicle}
                            onChange={addvalues}
                            name="Have_Any_Vehicle"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Do you Have Any Vehicle - </b>
                          {row[5].doyouHaveAnyVehicle}
                        </TableCell>
                      )}
                    </TableRow>
                    <TableRow>
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Vehicle Type - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[5].vehicleType}
                            value={data2.Vehicle_Type}
                            onChange={addvalues}
                            name="Vehicle_Type"
                            size="small"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Vehicle Type - </b>
                          {row[5].vehicleType}
                        </TableCell>
                      )}
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Registration No - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[5].rgno}
                            size="small"
                            value={data2.Registration_No}
                            onChange={addvalues}
                            name="Registration_No"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Registration No - </b>
                          {row[5].rgno}
                        </TableCell>
                      )}
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Do you have Any Credit Card - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[5].doyouhaveAnyCreditCard}
                            size="small"
                            value={data2.Have_Any_Credit_Card}
                            onChange={addvalues}
                            name="Have_Any_Credit_Card"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Do you have Any Credit Card - </b>
                          {row[5].doyouhaveAnyCreditCard}
                        </TableCell>
                      )}
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Higher Limit Credit Card - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[5].higherLimitCreditCard}
                            size="small"
                            value={data2.Higher_Limit}
                            onChange={addvalues}
                            name="Higher_Limit"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Higher Limit Credit Card - </b>
                          {row[5].higherLimitCreditCard}
                        </TableCell>
                      )}
                    </TableRow>
                    <TableRow>
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Card Limit - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[5].cardLimit}
                            size="small"
                            value={data2.Card_Limit}
                            onChange={addvalues}
                            name="Card_Limit"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Card Limit - </b>
                          {row[5].cardLimit}
                        </TableCell>
                      )}
                      {editcheck ? (
                        <TableCell>
                          <button
                            className="mt-5 accepted-bg px-3 p-1 rounded border-0 "
                            onClick={() => {
                              UpdateCreditCard(row[0]);
                            }}
                          >
                            save
                          </button>
                        </TableCell>
                      ) : (
                        <TableCell></TableCell>
                      )}
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  const [CreditCardInsurancedata, setCreditCardInsurancedata] = useState([
    // {
    //   id: 1,
    //   First_Name: "Yash",
    //   Last_Name: "Yash",
    //   Email_Address: "Yash@dfhdfghdf",
    //   Contact_Number: "616514654",
    //   Occupation_Type: "Salaried",
    //   Monthly_Income: "52146565",
    //   Residential_Pincode: "16546545",
    //   Have_Any_Vehicle: "Yes",
    //   Vehicle_Type: "Two Wheeler",
    //   Registration_No: "9351923946",
    //   Have_Any_Credit_Card: "Yes",
    //   Higher_Limit: "16145",
    //   Card_Limit: "9351923946",
    // },
    // {
    //   id: 2,
    //   First_Name: "Piyush",
    //   Last_Name: "Rai",
    //   Email_Address: "Piyus@jkj",
    //   Contact_Number: "465465465",
    //   Occupation_Type: "Self Employed",
    //   Monthly_Income: "46545",
    //   Residential_Pincode: "302001",
    //   Have_Any_Vehicle: "Yes",
    //   Vehicle_Type: "Four Wheeler",
    //   Registration_No: "6546546542",
    //   Have_Any_Credit_Card: "No",
    //   Higher_Limit: null,
    //   Card_Limit: null,
    // },
    // {
    //   id: 3,
    //   First_Name: "sdfsdf",
    //   Last_Name: "sadfasdf",
    //   Email_Address: "sdafasdf@fgsd",
    //   Contact_Number: "3213213213",
    //   Occupation_Type: "Salaried",
    //   Monthly_Income: "12132132",
    //   Residential_Pincode: "121321",
    //   Have_Any_Vehicle: "Yes",
    //   Vehicle_Type: "Four Wheeler",
    //   Registration_No: "211321321321321",
    //   Have_Any_Credit_Card: "Yes",
    //   Higher_Limit: "232132132",
    //   Card_Limit: "321321",
    // },
    // {
    //   id: 4,
    //   First_Name: "dfsgd",
    //   Last_Name: "dfsgsdfg",
    //   Email_Address: "dfsgdsfg@dfg",
    //   Contact_Number: "",
    //   Occupation_Type: "Salaried",
    //   Monthly_Income: "1111321",
    //   Residential_Pincode: "521654",
    //   Have_Any_Vehicle: "No",
    //   Vehicle_Type: null,
    //   Registration_No: null,
    //   Have_Any_Credit_Card: "No",
    //   Higher_Limit: null,
    //   Card_Limit: null,
    // },
  ]);

  const [tableName, settablename] = useState("credit_card_insurance");

  useEffect(() => {
    const getCreditCardInsurancedata = async () => {
      const url = `https://policydekhoo-backend.onrender.com/GetAllData?tableName=${tableName}`;

      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }).then((response => response.json()))
        if(response.msg!=="Error Fetching  data")
          {

            setCreditCardInsurancedata(response);
            setData(response)
        }

        
        // console.log("Groups:", data);
      } catch (error) {
        console.error("Error fetching groups:", error);
      }
    };

    getCreditCardInsurancedata();
  }, []);
  console.log(CreditCardInsurancedata,"[][][][][]")

  const rows = CreditCardInsurancedata.map((data) => [
    data.id,
    `${data.First_Name} ${data.Last_Name}`,
    data.Email_Address,
    data.Contact_Number,
    data.status,
    {
      occupationType: data.Occupation_Type,
      MonthlyIncome: data.Monthly_Income,
      currentResidentialPincode: data.Residential_Pincode,
      doyouHaveAnyVehicle: data.Have_Any_Vehicle,
      vehicleType: data.Vehicle_Type,
      rgno: data.Registration_No,
      doyouhaveAnyCreditCard: data.Have_Any_Credit_Card,
      higherLimitCreditCard: data.Higher_Limit,
      cardLimit: data.Card_Limit,
    },
  ]);

  const Column = ["Unique ID", "Name", "Email", "Contact"];

  return (
    <div className="fade">
      <h3>Credit Card</h3>
      <div className="row ">
        {/* <div className="col-12 my-sm-1 my-2 col-sm-4 col-md-3">
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            // options={top100Films}
            // sx={{ width: 280 }}
            renderInput={(params) => <TextField {...params} label="Search" />}
          />
        </div> */}

        <div className="text-end mx-2">
                  
                  <img src={ExcelIcon} width={"30rem"} className="me-4" style={{cursor:"pointer"}} alt="excelIcon" onClick={exportToExcel} />
        {/* <div className="col-12 my-sm-1 my-2 col-sm-3 col-md-2 "> */}
          {/* <TextField
            id="outlined-select-currency"
            select
            fullWidth
            label="Status"
            defaultValue={""}
          >
            {currencies.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField> */}
        </div>
      </div>
      <div className="row m-2">
        <Paper sx={{ overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: "60vh" }}>
            <Table aria-label="collapsible table" id="my-table">
              <TableHead>
                <TableRow>
                  <TableCell />
                  {Column.map((val, index) => (
                    <TableCell
                      className="text-left"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      <b>{val}</b>
                    </TableCell>
                  ))}
                  <TableCell sx={{ minWidth: 140 }} className="text-left">
                    <b>Status</b>
                  </TableCell>
                  { permissionsList.includes("edit")||permissionsList.includes("delete")?
                  <TableCell className="text-left">
                    <b>Actions</b>
                  </TableCell>
                  :""}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => (
                    <Row key={row.name} row={row} />
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={rowsPerPageOptions}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    </div>
  );
};

export default Credit;
